import { useState, useEffect } from "react";
import Divider from "@mui/material/Divider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import { PropagateLoader } from "react-spinners";
import "./subaccounts.css";

dayjs.locale("ru");

const SubAccounts = () => {
	const [selectedDate, setSelectedDate] = useState(dayjs());
	const [isLoading, setIsLoading] = useState(true);
	const [activeIndex, setActiveIndex] = useState(0);

	const popularSavings = [
		{ name: "ATOM", img: "/icons/atom.svg", amount: 0 },
		{ name: "SOL", img: "/icons/sol.svg", amount: 0 },
		{ name: "ICP", img: "/icons/icp.svg", amount: 0 },
		{ name: "AUD", img: "/icons/aud.svg", amount: 0 },
		{ name: "BCH", img: "/icons/bch.svg", amount: 0 },
		{ name: "USD", img: "/icons/usd.svg", amount: 0 },
		{ name: "SNX", img: "/icons/snx.svg", amount: 0 },
		{ name: "LINK", img: "/icons/link.svg", amount: 0 },
		{ name: "BNB", img: "/icons/bnb.svg", amount: 0 },
		{ name: "LTC", img: "/icons/ltc.svg", amount: 0 },
		{ name: "USDT", img: "/icons/usdt.svg", amount: 0 },
		{ name: "DOT", img: "/icons/dot.svg", amount: 0 },
		{ name: "XMR", img: "/icons/xmr.svg", amount: 0 },
	];

	// Функция для обновления активного элемента
	const handleClick = (index) => {
		setIsLoading(true);
		setActiveIndex(index);

		const timer = setTimeout(() => setIsLoading(false), 2500);

		return () => clearTimeout(timer); // Очистка таймера
	};

	useEffect(() => {
		const timer = setTimeout(() => setIsLoading(false), 2500);

		return () => clearTimeout(timer);
	}, []);

	// Обработчик изменения даты
	const handleDateChange = (date) => {
		setIsLoading(true);
		setSelectedDate(date);

		const timer = setTimeout(() => setIsLoading(false), 2500);

		return () => clearTimeout(timer); // Очистка таймера
	};

	return (
		<div className="subaccounts">
			<div className="subaccounts-header">
				{popularSavings.map((item, index) => (
					<div
						className={`subaccounts-header-item ${
							index === activeIndex ? "subaccounts-header-item-active" : ""
						}`}
						key={index}
						onClick={() => handleClick(index)} // Обработчик клика
					>
						<img src={item.img} alt="icon" />
						<p className="subaccounts-header-item-text">{item.name}</p>
						<p className="subaccounts-header-item-value">{item.amount}</p>
					</div>
				))}
			</div>
			<div className="accounts-table-info">
				<div className="accounts-table-info-item">
					<div className="accounts-table-info-item-left">
						<p className="accounts-table-info-item-left-text">Итоговый баланс</p>
						<p className="accounts-table-info-item-left-value">0.00 USD</p>
					</div>
					<div className="accounts-table-info-item-right">
						<div className="accounts-table-info-item-right-info">
							<div className="accounts-table-info-item-right-info-item">
								<p className="accounts-table-info-item-right-info-item-title">
									Всего инвестировано
								</p>
								<p className="accounts-table-info-item-right-info-item-value">
									0.00 USD
								</p>
							</div>
							<Divider orientation="vertical" flexItem={true} />
							<div className="accounts-table-info-item-right-info-item">
								<p className="accounts-table-info-item-right-info-item-title">
									Средний процент
								</p>
								<p className="accounts-table-info-item-right-info-item-value">0 %</p>
							</div>
							<Divider orientation="vertical" flexItem={true} />
							<div className="accounts-table-info-item-right-info-item">
								<p className="accounts-table-info-item-right-info-item-title">
									Совокупный итог
								</p>
								<p className="accounts-table-info-item-right-info-item-value">
									0.00 USD
								</p>
							</div>
						</div>
						<div className="accounts-table-info-item-right-actions">
							<LocalizationProvider dateAdapter={AdapterDayjs}>
								<DatePicker
									format="DD-MM-YYYY"
									value={selectedDate}
									onChange={(date) => handleDateChange(date)}
								/>
							</LocalizationProvider>
						</div>
					</div>
				</div>
				<div className="accounts-table-titles">
					<div className="accounts-table-titles-item">Инвестиции</div>
					<div className="accounts-table-titles-item">Ставка</div>
					<div className="accounts-table-titles-item">Период Инвестиции</div>
					<div className="accounts-table-titles-item">Статус</div>
					<div className="accounts-table-titles-item">Общий итог</div>
				</div>
				<div className="accounts-table-rows">
					{isLoading ? (
						<PropagateLoader color="#b7c4ff" />
					) : (
						<>
							<img src="/icons/cloud.svg" alt="empty-icon" />
							<p className="accounts-table-rows-empty">Не найдено инвестиций</p>
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default SubAccounts;
